function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import chunked from "../chunked";
import { create as createEntry, reset as resetEntry, compare as compareEntry, markRemoved as markEntryRemoved, markFetching as markEntryFetching, markFetched as markEntryFetched, markErrored as markEntryErrored, canFulfill as canFulfillEntry, STATUS_FETCHING } from "./entry";
import { delivery, adobeValues, MAX_MBOXES_PER_REQUEST } from "./apis";
import { getRemotePageParameters } from "../../hocs/federated-target-page-parameters";
import { broadcastToDocument } from "../events";
import { isDebugging, getGlobalLapel } from "../debug";
import logger from "../../logger";
import globalConfig from "../../config";
import { getFlag, getPersonalizationClientId } from "../ld-cache";
var debugging = isDebugging();
// Create Top-Level in-memory cache
var cache = [];
var globalSubscribers = [];
function notifySubscribers() {
    globalSubscribers.forEach(function(subscriber) {
        return subscriber(cache);
    });
}
function subscribe(callback) {
    globalSubscribers.push(callback);
    return function() {
        var index = globalSubscribers.indexOf(callback);
        if (index !== -1) {
            globalSubscribers.splice(index, 1);
        }
    };
}
// Scan for valid fetchable entries
function scan() {
    return cache.filter(function(entry) {
        return canFulfillEntry(entry);
    });
}
/**
 * This calls the delivery API to fulfill a chunk of mboxes.
 * @param {array} chunk
 * @param {object} pageParameters page parameters added to each mbox in the request
 * @returns {Promise}
 */ var fufillChunk = /*#__PURE__*/ _async_to_generator(function(chunk, pageParameters) {
    var mboxes;
    return _ts_generator(this, function(_state) {
        // Mark entries as fetching with proper index
        chunk.forEach(function(entry, index) {
            return markEntryFetching(entry, index);
        });
        mboxes = chunk.map(function(param) {
            var _param_config = param.config, name = _param_config.name, parameters = _param_config.parameters, profileParameters = _param_config.profileParameters, _param_state = param.state, index = _param_state.fetching;
            return {
                name: name,
                parameters: _extends({
                    lapel: true,
                    mbox3rdPartyId: adobeValues.thirdPartyId
                }, pageParameters, parameters),
                profileParameters: profileParameters,
                index: index
            };
        });
        logger.log("Attempting to fulfill mboxes", mboxes);
        return [
            2,
            delivery({
                execute: {
                    mboxes: mboxes
                }
            }).then(function(results) {
                var _results_execute, _results;
                (_results = results) == null ? void 0 : (_results_execute = _results.execute) == null ? void 0 : _results_execute.mboxes.forEach(function(returnedMbox) {
                    var index = returnedMbox.index, options = returnedMbox.options;
                    // Scan items being fetched for a matching index created during preperation
                    var entry = chunk.find(function(fetched) {
                        // Skip entries which have already been processed
                        if (fetched.state.status !== STATUS_FETCHING) {
                            return false;
                        }
                        return fetched.state.fetching === index;
                    });
                    if (!entry) {
                        logger.warn(// Was the entry removed in the middle of the request?
                        "No matching entry for response at index " + index, returnedMbox);
                        return;
                    }
                    // Overwrite entrys payload property with most recent data
                    markEntryFetched(entry, {
                        options: options
                    });
                });
                // There may be entries that never received a response, mark them as errored.
                // Likely only happens during tests that only respond with a single mbox.
                chunk.forEach(function(entry) {
                    if (entry.state.status === STATUS_FETCHING) {
                        markEntryErrored(entry, new Error("No matching mbox in response."));
                    }
                });
                // These events let apps know about the delivery lifecycle which is used for analytics
                broadcastToDocument("LAPEL_BATCH_REQUEST_SUCCESS");
                return results;
            }).catch(function(err) {
                chunk.forEach(function(entry) {
                    return markEntryErrored(entry, err);
                });
                // These events let apps know about the delivery lifecycle which is used for analytics
                broadcastToDocument("LAPEL_BATCH_REQUEST_ERRORED");
                return err;
            }).finally(function() {
                // These events let apps know about the delivery lifecycle which is used for analytics
                broadcastToDocument("LAPEL_BATCH_REQUEST_COMPLETE");
                notifySubscribers();
            })
        ];
    });
});
/**
 * Scan and fulfill all entries in the cache, chunking them into requests of MAX_MBOXES_PER_REQUEST size
 * @returns {Promise}
 */ var fulfillImmediate = /*#__PURE__*/ _async_to_generator(function() {
    var _window, fetchable, globalParameters, _tmp, pageParameters, combinedParameters, promises, chunks, chunk;
    return _ts_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                fetchable = scan();
                if (!fetchable || fetchable.length === 0) {
                    throw new Error("Nothing in cache to fulfill");
                }
                // Mark entries as fetching without index to stop duplicate requests
                fetchable.forEach(function(entry) {
                    return markEntryFetching(entry);
                });
                if (!((_window = window) == null ? void 0 : _window.targetPageParams)) return [
                    3,
                    2
                ];
                return [
                    4,
                    window.targetPageParams()
                ];
            case 1:
                _tmp = _state.sent();
                return [
                    3,
                    3
                ];
            case 2:
                _tmp = {};
                _state.label = 3;
            case 3:
                globalParameters = _tmp;
                return [
                    4,
                    getRemotePageParameters()
                ];
            case 4:
                pageParameters = _state.sent();
                combinedParameters = _extends({}, globalParameters, pageParameters);
                promises = [];
                chunks = chunked(fetchable, MAX_MBOXES_PER_REQUEST);
                chunk = chunks.next();
                while(!chunk.done){
                    promises.push(fufillChunk(chunk.value, combinedParameters));
                    chunk = chunks.next();
                }
                return [
                    2,
                    Promise.all(promises)
                ];
        }
    });
});
// Fetch all entries in cache after a delay
// Don't fetch if there is a pending fetch
var fulfill = function() {
    var bufferTimeout = null;
    var promise;
    var resolve;
    var reject;
    var _globalConfig_lpeCache_defaultDebounceTime;
    // returns a function that can be called to fulfill a cache after a delay
    return function(ms) {
        if (ms === void 0) ms = function() {
            var _globalConfig_lpeCache, _globalConfig;
            return (_globalConfig_lpeCache_defaultDebounceTime = (_globalConfig = globalConfig()) == null ? void 0 : (_globalConfig_lpeCache = _globalConfig.lpeCache) == null ? void 0 : _globalConfig_lpeCache.defaultDebounceTime) != null ? _globalConfig_lpeCache_defaultDebounceTime : 0;
        }();
        // Server side personalization is not supported
        if (typeof window === "undefined") {
            return Promise.resolve();
        }
        if (bufferTimeout != null) {
            return promise;
        }
        // Store a reference to the promise so we can return it later and cancel it if needed
        promise = new Promise(function(res, rej) {
            resolve = res;
            reject = rej;
        });
        // Set timeout to execute fetch
        bufferTimeout = setTimeout(/*#__PURE__*/ _async_to_generator(function() {
            var resultPromise, err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        resultPromise = fulfillImmediate();
                        bufferTimeout = null;
                        return [
                            4,
                            resultPromise
                        ];
                    case 1:
                        resolve.apply(void 0, [
                            _state.sent()
                        ]);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        bufferTimeout = null;
                        reject(err);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        }), ms);
        return promise;
    };
}();
// The main lookup function to pair a input to an output.
function match(incoming) {
    return cache.find(function(existing) {
        return compareEntry(incoming, existing);
    });
}
function insert(entry) {
    var useNewCache = getFlag("replace-lapel-legacy-cache", false, getPersonalizationClientId());
    if (!useNewCache) {
        logger.warn("Attempted to insert entry into cache v2 while using legacy cache. This is not supported.", entry);
        return null;
    }
    // Validate function input meets bare minimum of a cache entry
    if (!entry.config || // exists
    !entry.config.name || // is object with name property
    typeof entry.config.name !== "string" // name property is correct type
    ) {
        // Exit quickly if bad inputs
        logger.warn("Attempted to insert invalid cache entry; Expected entry.config.name to be a string.", entry);
        return null;
    }
    // If the config matches an existing config, return existing entry
    var existingEntry = match(entry);
    if (existingEntry) {
        // if the new insert is immediate but the existing is not
        // and the existing entry has not been fetched, attempt to fulfill the existing
        if (entry.config.immediate === true && canFulfillEntry(existingEntry)) {
            fulfill().catch(function(err) {
                return logger.error(err);
            });
        }
        notifySubscribers();
        return existingEntry;
    }
    // Create and insert new entry //
    // eslint-disable-next-line no-param-reassign
    entry = createEntry(entry);
    // Add a new Cache entry
    cache.push(entry);
    // sort by specificity on insert
    cache.sort(function(a, b) {
        return b.state.specificity - a.state.specificity;
    });
    // Trigger a fetch upon insertion
    if (entry.config.immediate === true) {
        fulfill().catch(function(err) {
            return logger.error(err);
        });
    }
    notifySubscribers();
    return entry;
}
// Calls reset on all entries, reseting their state and payloads
function reset() {
    cache.forEach(function(entry) {
        resetEntry(entry);
    });
    notifySubscribers();
}
function remove(entry) {
    // Remove cache entries matching config
    var index = cache.findIndex(function(existing) {
        return compareEntry(entry, existing);
    });
    if (index > -1) {
        cache.splice(index, 1);
        markEntryRemoved(entry);
    }
    notifySubscribers();
}
function clear() {
    while(cache.length > 0){
        var entry = cache.pop();
        markEntryRemoved(entry);
    }
    notifySubscribers();
}
if (debugging) {
    // eslint-disable-next-line no-param-reassign
    var lapel = getGlobalLapel();
    lapel.LPE = {
        cache: cache,
        get cacheByName () {
            return cache.reduce(function(acc, entry) {
                if (!acc[entry.config.name]) {
                    acc[entry.config.name] = [];
                }
                acc[entry.config.name].push(entry);
                return acc;
            }, {});
        },
        get cacheByPath () {
            return cache.reduce(function(acc, entry) {
                if (!acc[entry.config.path]) {
                    acc[entry.config.path] = [];
                }
                acc[entry.config.path].push(entry);
                return acc;
            }, {});
        },
        markEntryErrored: markEntryErrored,
        markEntryFetching: markEntryFetching,
        markEntryFetched: markEntryFetched,
        resetEntry: resetEntry,
        compareEntry: compareEntry
    };
}
export { cache, match, insert, reset, remove, clear, fulfill, fulfillImmediate, scan, notifySubscribers, subscribe };

//# sourceMappingURL=cache.js.map